import { Formik } from "formik";
import { Switch } from "@material-ui/core";
import { Form, Col, Row } from "react-bootstrap";

export function EducationTermEditForm({ 
  educationTerm,
  btnRef,
  saveEducationTerm
}) {
  return (
    <Formik 
      enableReinitialize={true}
      initialValues={educationTerm}
      onSubmit={(values) => {
        const formValues = { ...values };
        if (formValues.secondSemesterStart === "") formValues.secondSemesterStart = null;
        if (formValues.secondSemesterEnd === "") formValues.secondSemesterEnd = null;
        if (formValues.thirdSemesterStart === "") formValues.thirdSemesterStart = null;
        if (formValues.thirdSemesterEnd === "") formValues.thirdSemesterEnd = null;
        if (formValues.fourthSemesterStart === "") formValues.fourthSemesterStart = null;
        if (formValues.fourthSemesterEnd === "") formValues.fourthSemesterEnd = null;
        saveEducationTerm(formValues);
      }}
    >
      {({ handleSubmit, handleChange, values }) => (
        <Form onSubmit={(e) => {
          e.preventDefault();
          handleSubmit();
        }}>
          <div className="row">
            <div className="col-6">
              <Form.Group as={Row} controlId="firstSemesterStart">
                <Form.Label column sm={5}>
                  Birinci Dönem Başlangıcı<span> *</span>
                </Form.Label>
                <Col sm={7}>
                  <Form.Control type="date" value={values.firstSemesterStart} placeholder="Birinci Dönem Başlangıcı" onChange={handleChange} />
                </Col>
              </Form.Group>

              {
                educationTerm.semesterCount > 1 &&
                <Form.Group as={Row} controlId="secondSemesterStart">
                  <Form.Label column sm={5}>
                    İkinci Dönem Başlangıcı<span> *</span>
                  </Form.Label>
                  <Col sm={7}>
                    <Form.Control type="date" value={values.secondSemesterStart} placeholder="İkinci Dönem Başlangıcı" onChange={handleChange} />
                  </Col>
                </Form.Group>
              }

              {
                educationTerm.semesterCount > 2 &&
                <Form.Group as={Row} controlId="thirdSemesterStart">
                  <Form.Label column sm={5}>
                    Üçüncü Dönem Başlangıcı<span> *</span>
                  </Form.Label>
                  <Col sm={7}>
                    <Form.Control type="date" value={values.thirdSemesterStart} placeholder="Üçüncü Dönem Başlangıcı" onChange={handleChange} />
                  </Col>
                </Form.Group>
              }

              {
                educationTerm.semesterCount > 3 &&
                <Form.Group as={Row} controlId="fourthSemesterStart">
                  <Form.Label column sm={5}>
                    Dördüncü Dönem Başlangıcı<span> *</span>
                  </Form.Label>
                  <Col sm={7}>
                    <Form.Control type="date" value={values.fourthSemesterStart} placeholder="Dördüncü Dönem Başlangıcı" onChange={handleChange} />
                  </Col>
                </Form.Group>
              }
              
              <Form.Group as={Row} controlId="isActive">
                <Form.Label column sm={2}>
                  Aktif mi?
                </Form.Label>
                <Col sm={10}>
                  <Switch checked={values.isActive} onChange={handleChange("isActive")} />
                </Col>
              </Form.Group>
            </div>

            <div className="col-6">
              <Form.Group as={Row} controlId="firstSemesterEnd">
                <Form.Label column sm={5}>
                  Birinci Dönem Sonu<span> *</span>
                </Form.Label>
                <Col sm={7}>
                  <Form.Control type="date" value={values.firstSemesterEnd} placeholder="Birinci Dönem Sonu" onChange={handleChange} />
                </Col>
              </Form.Group>

              {
                educationTerm.semesterCount > 1 &&
                <Form.Group as={Row} controlId="secondSemesterEnd">
                  <Form.Label column sm={5}>
                    İkinci Dönem Sonu<span> *</span>
                  </Form.Label>
                  <Col sm={7}>
                    <Form.Control type="date" value={values.secondSemesterEnd} placeholder="İkinci Dönem Sonu" onChange={handleChange} />
                  </Col>
                </Form.Group>
              }

              {
                educationTerm.semesterCount > 2 &&
                <Form.Group as={Row} controlId="thirdSemesterEnd">
                  <Form.Label column sm={5}>
                    Üçüncü Dönem Sonu<span> *</span>
                  </Form.Label>
                  <Col sm={7}>
                    <Form.Control type="date" value={values.thirdSemesterEnd} placeholder="Üçüncü Dönem Sonu" onChange={handleChange} />
                  </Col>
                </Form.Group>
              }

              {
                educationTerm.semesterCount > 3 &&
                <Form.Group as={Row} controlId="fourthSemesterEnd">
                  <Form.Label column sm={5}>
                    Dördüncü Dönem Sonu<span> *</span>
                  </Form.Label>
                  <Col sm={7}>
                    <Form.Control type="date" value={values.fourthSemesterEnd} placeholder="Dördüncü Dönem Sonu" onChange={handleChange} />
                  </Col>
                </Form.Group>
              }
            </div>
          </div>
          
          <button
            type="submit"
            style={{ display: "none" }}
            ref={btnRef}
          ></button>
        </Form>
      )}      
    </Formik>
  );
}